module.exports = __webpack_public_path__ + "media/images/footer/Rectangle 6.2-892b3bc49162746aff35d7f17cbf1f03.png";